import React from 'react';
import { connect } from 'react-redux';
import { clearError } from './actions';
import NotFoundPage from 'components/errorPages/NotFound';
import UncaughtErrorPage from 'components/errorPages/UncaughtErrorPage';

class ErrorBoundary extends React.Component {
  state = { error: null };

  componentDidCatch(error, info) {
    this.setState({ error });
    console.error(error, info); // eslint-disable-line no-console
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ error: null });
      this.props.clearError();
    }
  }

  render() {
    const ErrorBoundaryContainer = this.props.container;
    const error = this.state.error || this.props.error;

    if (error && (error.status || error.message)) {
      return (
        <ErrorBoundaryContainer>
          {error.status === 404 ? <NotFoundPage /> : <UncaughtErrorPage />}
        </ErrorBoundaryContainer>
      );
    } else {
      return this.props.children;
    }
  }
}

ErrorBoundary.defaultProps = {
  container: function Container({ children }) {
    return children;
  }
};

const ConnectedErrorBoundary = connect(
  state => ({
    error: state.error
  }),
  { clearError }
)(ErrorBoundary);

export default ConnectedErrorBoundary;
